/**
 * TIME MEASURES
 */
export const ONE_SECOND_IN_MILISECONDS = 1000;
export const ONE_DAY_IN_MILISECONDS = 86400000;
